import React from 'react';
import ChoiceCard from './ChoiceCard';
import ConfirmCard from './ConfirmCard';
import SuggestionCard from './SuggestionCard';

const CARD_COMPONENTS = {
  choice: ChoiceCard,
  confirm: ConfirmCard,
  suggestion: SuggestionCard,
};

export default function DynamicCard({ cardData, onRespond }) {
  const Component = CARD_COMPONENTS[cardData.type];
  if (!Component) return null;

  // Collapse answered cards to a compact summary
  if (cardData.answered) {
    return (
      <div className="ws-card ws-card--collapsed">
        <span className="ws-card__check material-icons">check_circle</span>
        <span className="ws-card__collapsed-text">
          {cardData.title ? `${cardData.title}: ` : ''}
          {cardData.response}
        </span>
      </div>
    );
  }

  return (
    <div className="ws-card">
      <Component data={cardData} onRespond={onRespond} />
    </div>
  );
}
